import { useEffect, useState } from 'react';
import { subscribeIncomingGroupInvites } from '../api/groupService';

/** Live pending group invites for the signed-in user (client read only). */
export function useGroupInvites(userId) {
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    if (!userId) {
      setInvites([]);
      return undefined;
    }
    return subscribeIncomingGroupInvites(userId, setInvites, () => setInvites([]));
  }, [userId]);

  return invites;
}
